import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	value: null,
};

export const resSlice = createSlice({
	name: "branch",
	initialState,
	reducers: {
		add_details: (state, action) => {
			state.value = action.payload;
		},
	},
});

export const { add_details } = resSlice.actions;

export default resSlice.reducer;
